import { useQueryClient } from 'react-query';

import {
  eventLeadsApiKeys,
  useEventLeadsApi,
} from '../../../../hooks/api/event-leads/useEventLeadsApi';
import { useSearchApi } from '../../../../hooks/api/useSearchApi';
import type { SearchApiOptions } from '../../../../types/api';
import type {
  EventLeadSearchFacetFields,
  EventLeadSearchItem,
  EventLeadSearchParams,
  EventLeadSearchResults,
} from '../../../../types/events/leads';

export function useSearchEventLeads(
  organizationId: string,
  params: Partial<EventLeadSearchParams>,
  {
    enabled = true,
    ...options
  }: Omit<
    Partial<
      SearchApiOptions<
        EventLeadSearchItem,
        EventLeadSearchFacetFields,
        EventLeadSearchResults
      >
    >,
    'page' | 'queryKey' | 'request'
  > = {}
) {
  const queryClient = useQueryClient();
  const api = useEventLeadsApi();
  const result = useSearchApi<
    EventLeadSearchItem,
    EventLeadSearchFacetFields,
    EventLeadSearchResults
  >({
    enabled: !!organizationId && enabled,
    queryKey: eventLeadsApiKeys.search(organizationId, params),
    request: () => api.search(organizationId, params),
    ...options,
  });
  return {
    ...result,
    invalidate: () =>
      queryClient.invalidateQueries(
        eventLeadsApiKeys.search(organizationId, params)
      ),
  };
}
